import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'antd';
import { notification, Flex } from 'ui';
import QuestionSection from '../form/question-section';

const Text = styled.p`
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
`;

const Buttons = styled(Flex)`
  > :first-child {
    margin-right: 5px;
  }
  justify-content: flex-end;
  margin-top: 15px;
`;

export const StyledButton = styled(Button)`
  text-transform: uppercase;
  border: 2px solid #6f7e95 !important;
  color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
  background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  &:hover {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
    opacity: 0.7 !important;
  }
  &:focus {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  }
  &:disabled {
    opacity: 0.7;
  }
  ${p => p.marginTop && `margin-top: ${p.marginTop}px`};
`;


export const QuestionWrapper = styled.div`
  margin: 15px 0;
`;

const QuestionWarningNotification = ({
  intl,
  onConfirm,
  questionData = [],
  tags = [],
}) => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    if (questionData?.length) {
      setQuestions(questionData);
    }
  }, [questionData]);

  const handleAnswer = (e) => {
    setAnswers(state => [...state, e]);
  };
  const handleUndo = (e) => {
    setAnswers(state => state?.filter(i => i !== e));
  };

  const handleClose = () => {
    setQuestions([]);
    setAnswers([]);
  };

  return (
    <>
      <Text>{intl.formatMessage({ id: 'ticket.QUESTION_WARNING_INFO' })}</Text>
      <Text marginTop={15}>
        {intl.formatMessage({ id: 'ticket.QUESTION_WARNING_INSTRUCTIONS' })}
      </Text>
      <QuestionWrapper>
        <QuestionSection
          intl={intl}
          questions={questions}
          setQuestions={setQuestions}
          handleQuestionAnswer={handleAnswer}
          handleQuestionUndo={handleUndo}
          hasUnknown={true}
          canUndo={true}
        />
      </QuestionWrapper>
      <Buttons>
        <StyledButton
          onClick={() => {
            handleClose();
            notification.destroy('openQuestionsWarning');
          }}
        >
          {intl.formatMessage({ id: 'common.CANCEL' })}
        </StyledButton>
        <StyledButton
          primary={1}
          onClick={() => {
            onConfirm(answers.map(a => tags.find(t => t.id === a) || a));
            notification.destroy('openQuestionsWarning');
          }}
          disabled={answers.length !== questions.length}
        >
          {intl.formatMessage({ id: 'ticket.CLOSE_TICKET' })}
        </StyledButton>
      </Buttons>
    </>
  );
};
QuestionWarningNotification.propTypes = {
  intl: PropTypes.object,
  onConfirm: PropTypes.func,
  questionData: PropTypes.array,
  tags: PropTypes.array,
};

export default QuestionWarningNotification;
